import {
    allFetch
} from "../Domain";

/**
 * @description 問卷
 */
export const Questionnaire = (() => {
    /**
     * @description 查詢問卷
     */
    const SearchQuestionnaire = async function (obj = {
        Plant: '',
        isOpen: ''
    }) {
        return await allFetch('Questionnaire/SearchQuestionnaire', obj);
    }
    return {
        SearchQuestionnaire,
    }
})();
